module.exports = __webpack_public_path__ + "nc_static/media/sw-rejected.771f7d1c.svg";